

const decodePolylineForWebWorker = (data) => {
    return new Promise((resolve, reject) => {
      const worker = new Worker(new URL('../../workers/decodePolylineWorker.js', import.meta.url));
  
      worker.postMessage(data);
  
      worker.onmessage = (event) => {
        // Eğer hata mesajı geldiyse reject edebiliriz.
        if (event.data && event.data.error) {
          reject(new Error(event.data.error));
        } else {
          resolve(event.data);
        }
        worker.terminate();
      };
  
      worker.onerror = (error) => {
        reject(error);
        worker.terminate();
      };
    });
  }
  
export default decodePolylineForWebWorker